import { cpqAxiosWithToken } from "../http-common";
import { Congiguration } from "../Constants/AppConstants";

class UserService {
  getLoggedinUserDetails(userEmail) {
    return cpqAxiosWithToken.get(
      `/UserDetail/UserDetailsActions/?userEmail=${userEmail}&companyId=${Congiguration.CompanyId}`
    );
  }

  getAllUsersandAllRoles() {
    return cpqAxiosWithToken.get(
      `UserDetail/AllUsersRolesAndActions/?companyId=${Congiguration.CompanyId}`    
    );
  }
  getUserInfofromAD(userEmail) {
    return cpqAxiosWithToken.get(
      `UserDetail/UserInfofromAD/?userEmail=${userEmail}&companyId=${Congiguration.CompanyId}`
    );
  }
  SaveNewUserDetails(data) {
    return cpqAxiosWithToken.post(`/UserDetail/UpdateUserInfoAndRole`, data);
  }
  SaveUpdateRoleAndPrevilage(data) {
    return cpqAxiosWithToken.post(`/UserDetail/UpdateRoleAndPrevilage`, data);
  }
}

export default new UserService();
